<template>
  <Phone
    show-placeholder
    :form-name="'update-phone-number-from-verification'"
    autofocus
    :show-help-text="false"
    class="mb-6"
    event-sufix="PhoneVerification"
    @keyup.enter="validateForm"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import phoneVerification from '@/mixins/phoneVerification';
export default {
  name: 'PhoneVerificationSecondStep',
  mixins: [phoneVerification],
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions({
      setDialogLoading: 'profile/phoneVerification/setDialogLoading',
      setDialogTitle: 'profile/phoneVerification/setDialogTitle',
      setDialogLeftHeaderIcon: 'profile/phoneVerification/setDialogLeftHeaderIcon',
      setDialogButtons: 'profile/phoneVerification/setDialogButtons'
    }),
    validateForm() {
      this.$eventHub.$emit('validatePhonePhoneVerification', () => {
        this.submitForm();
      });
    },
    submitForm() {
      if (this.isValidPhone) {
        this.sendForm();
      } else {
        this.$nextTick(() => this.scrollToError());
      }
    },
    sendForm() {
      this.loading = true;
      // TODO: migrate to patchUser helper
      this.$http
        .patch('/v3/fe/web-users', {
          phone: this.phone
        })
        .then(async () => {
          await this.$auth.fetchUser();
          await this.resendPhoneVerification();
          await this.$router.push(
            this.$localePath({
              name: this.currentPath,
              query: { ...this.$route.query, pv_step: 1 }
            })
          );
        })
        .catch(err => {
          this.handleError({ error: err, code: '0x00000017' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setButtons() {
      this.setDialogButtons([
        {
          type: 'sendButton',
          props: {
            inverted: true,
            loading: this.loading
          },
          events: {
            click: () => {
              this.validateForm();
            }
          },
          text: this.$t('phoneChange.sendCode')
        }
      ]);
    }
  },
  watch: {
    loading() {
      this.setButtons();
    }
  },
  computed: {
    ...mapGetters({
      isValidPhone: 'forms/phone/isValid',
      phone: 'forms/phone/phone'
    })
  },
  mounted() {
    this.setDialogTitle(this.$t('phoneChange.title'));
    this.setDialogLeftHeaderIcon('icons/phone.svg');
    this.setButtons();
    this.dialogScrollTop();
  }
};
</script>
